import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
// img
import u1 from "../../../../Assets/images/i1.png";
import Select from "react-select";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  getSmsTemplate_Details,
  smsTemplates_Update,
} from "../../../../store/actions";

const SMSTemp = () => {
  const dispatch = useDispatch();
  const [state, setState] = useState({
    smsTemplateId: "",
    title: "",
    body: "",
  });
  const SmstemplatesData = useSelector((s) => s.Setting.getSmsTemplates?.data);

  const selectOptions = SmstemplatesData?.map(({ _id, title }) => ({
    value: _id,
    label: title,
  }));
  console.log(selectOptions, "selectOptions");

  const handleDropDown = (e) => {
    // let fvalue = e.target.value;
    console.log(e, "fvalue");
    var selectedTemplate = SmstemplatesData.filter((element) => {
      return element._id === e.value;
    });
    console.log(selectedTemplate, "selectedTemp");
    setState((pre) => ({
      ...pre,

      body: selectedTemplate[0].body,
      title: selectedTemplate[0].title,
      smsTemplatedata: {
        value: selectedTemplate[0]._id,
        label: selectedTemplate[0].title,
      },
      smsTemplateId: selectedTemplate[0]._id,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const callBack = (response) => {
      if (response.status == "success") {
        toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    };
    dispatch(smsTemplates_Update(state, callBack));
  };
  useEffect(() => {
    dispatch(getSmsTemplate_Details());
  }, []);

  return (
    <>
      <section className="position-relative py-5 configuration">
        <Container>
          <Row className="justify-content-center">
            <Col lg="9" className="my-2">
              <Form>
                <div className="formWrpper px-sm-4 box p-3 pb-5">
                  <Row>
                    <Col md="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        SELECT SMS TEMPLATE
                      </label>
                      <Select
                        className={"bg-transparent"}
                        classNamePrefix="rental"
                        options={selectOptions}
                        value={state?.smsTemplatedata}
                        onChange={handleDropDown}
                        styles={{
                          container: (baseStyles) => ({
                            ...baseStyles,
                            width: "100%",
                          }),
                          control: (baseStyles) => ({
                            ...baseStyles,
                            backgroundColor: "transparent",
                            borderRadius: "5px",
                          }),
                        }}
                      />{" "}
                    </Col>
                    <Col md="6" className="my-2">
                      <label
                        htmlFor=""
                        className="form-label m-0 fw-sbold text-muted ps-2"
                      >
                        SMS TITLE
                      </label>
                      <input
                        type="text"
                        value={state.body}
                        name="body"
                        onChange={handleChange}
                        className="form-control bg-white mt-2"
                      />
                    </Col>
                  </Row>
                </div>
                <div className="btnWrpper mt-4 text-center">
                  <Button
                    onClick={handleSubmit}
                    className="d-inline-flex h-auto align-items-center justify-content-center commonBtn px-5"
                  >
                    Save
                  </Button>
                </div>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default SMSTemp;
